import { Link } from 'react-router-dom';

/**
 * Footer component with legal links
 * @param {Object} props
 * @param {'gradient' | 'default'} props.variant - 'gradient' for public pages, 'default' for dashboard
 */
export default function Footer({ variant = 'default' }) {
  const currentYear = new Date().getFullYear();

  const isGradient = variant === 'gradient';

  return (
    <footer className={`border-t ${isGradient ? 'border-white/20 bg-transparent' : 'border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg'}`}>
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Legal Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link
              to="/terms"
              className={`text-sm transition-colors ${
                isGradient
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              className={`text-sm transition-colors ${
                isGradient
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              Privacy Policy
            </Link>
            <Link
              to="/paia"
              className={`text-sm transition-colors ${
                isGradient
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              PAIA Manual
            </Link>
            <Link
              to="/blog"
              className={`text-sm transition-colors ${
                isGradient
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`}
            >
              Blog
            </Link>
          </nav>

          {/* Copyright */}
          <p className={`text-sm ${
            isGradient
              ? 'text-gray-400'
              : 'text-gray-500 dark:text-gray-500'
          }`}>
            &copy; {currentYear} SureDox. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
